import { z } from "zod";

export const cityCreateSchema = z.object({
  name: z.string().min(1, "Name is required"),
});

export const cityUpdateSchema = z.object({
  name: z.string().min(1, "Name is required").optional(),
});

export type CityFormData = z.infer<typeof cityCreateSchema>;
export type CityUpdateFormData = z.infer<typeof cityUpdateSchema>;

export interface CityRegion {
  id: string;
  name: string;
  cityId?: string;
  tenantId?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface City {
  id: string;
  name: string;
  tenantId: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
  regions: CityRegion[];
}

export interface CitiesResponse {
  cities: City[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface CityFilters {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface CityRequest {
  name: string;
}

export interface UpdateCityPayload {
  id: string;
  city: CityUpdateFormData;
}
